import type { RunMetricsResponse } from '@/entities/run/domain/runManagementTypes';

export type ExecutionResultModalMetric = {
  name: string;
  currentValue: number;
  history: Array<{ step: number; value: number }>;
};

export function mapRunMetricsResponseToExecutionModalMetrics(res: RunMetricsResponse): ExecutionResultModalMetric[] {
  const finalKeys = res.final ? Object.keys(res.final) : [];
  const historyKeys = res.history ? Object.keys(res.history) : [];
  const names = new Set([...finalKeys, ...historyKeys]);

  return Array.from(names).map((name) => {
    const series = res.history?.[name] ?? [];
    const lastFromHistory = series.length ? series[series.length - 1]!.value : 0;
    const currentValue = res.final?.[name] ?? lastFromHistory;
    const history = series.map((p) => ({ step: p.step, value: p.value }));
    return { name, currentValue, history };
  });
}
